import { addHours, isBefore } from 'date-fns'
import { orderStatuses } from '../config'

export const hasPrice = order => order.totalPrice && order.currency && order.priceFetchedAt

export const hasNoPrice = order => !order.totalPrice || !order.currency || !order.priceFetchedAt

export const hasPriceUnkown = order => !!order.priceFetchLastTryAt && !hasPrice(order)

// waiting for next price try is true if the last price try was more than 1 hour ago
export const waitingForNextPriceTry = order =>
  isBefore(new Date(), addHours(new Date(order.priceFetchLastTryAt), 1))

// can be sent is true if the order is not sent and has a price
export const canBeSent = order => order.status === orderStatuses.NOT_SENT && hasPrice(order)
